<template>
  <section>
    <!--Cabeçalho de consulta-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <!-- <el-form ref="formRule" :model="formRule" label-width="80px" size="mini"> -->
      <el-form size="mini">
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click.native.prevent="showDialogInsert()">Novo
            Cliente</el-button>
          <!-- <el-button type="primary" icon="el-icon-search" :loading=formRule.listLoading @click.native.prevent="getListaNfe(null, null)">Buscar</el-button> -->
        </el-form-item>
      </el-form>
    </el-col>
    <!--Tabela de dados-->
    <el-table stripe size=small ref="tableData" :data=listaClientes v-loading=listLoading empty-text=' '
      style="width: 100%;">
      <el-table-column label="Ativo" width="55" align=center>
        <template slot-scope="scope">
          <el-tag size='mini' type="success" disable-transitions v-if="scope.row.ativo === 'S'">Sim</el-tag>
          <el-tag size='mini' type="danger" disable-transitions v-if="scope.row.ativo === 'N'">Não</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="cnpjFormat" label="CNPJ" width="130">
      </el-table-column>
      <el-table-column prop="razaoSocial" label="Nome">
      </el-table-column>
      <!-- <el-table-column prop="apelido" label="Apelido" width="115"> -->
      <el-table-column prop="apelido" label="Apelido">
      </el-table-column>
      <el-table-column prop="telefone" label="Telefone" width="101" align=right>
      </el-table-column>
      <!-- <el-table-column prop="contato" label="Contato" width="110"> -->
      <el-table-column prop="contato" label="Contato">
      </el-table-column>
      <!-- <el-table-column prop="cidade" label="Cidade" width="175"> -->
      <el-table-column prop="cidade" label="Cidade">
      </el-table-column>
      <el-table-column label="Ações" width="140" align=center>
        <template slot-scope="clientes">
          <el-tooltip class="item" effect="dark" content="Download de todos XML's deste cliente" placement="bottom">
            <el-button plain type="primary" size=small icon="fa fa-cloud-download" circle
              @click.native="downloadXmlCliente(clientes.row.cnpj)"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="Editar cliente" placement="bottom">
            <el-button plain type="primary" size=small icon="fa fa-pencil" circle
              @click.native="showDialogEdit(clientes.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="Excluir cliente" placement="bottom">
            <el-button plain type="danger" size=small icon="fa fa-trash" circle
              @click.native="deleteCliente(clientes.row.cnpj, clientes.row.cnpjFormat, clientes.row.razaoSocial)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24" class="toolbar">
      <el-pagination layout="sizes, prev, pager, next, total" @current-change="handleCurrentChange"
        @size-change="handleSizeChange" :page-size="pageSize" :total="totalReg" :page-sizes="[5, 10, 15, 20, 25, 30]"
        style="float:right;">
      </el-pagination>
    </el-col>
    <!-- Dialog responsavel por mostrar o form de inclusao/alteracao do cadastro de clientes -->
    <el-dialog v-if="dialogCreated" title="Cadastro do cliente" :show-close="false" :visible.sync="dialogVisible"
      width="60%">
      <el-form ref="formClient" :model="formClient" label-width="100px" size="small">
        <el-col :span="12">
          <el-form-item label="CNPJ">
            <el-input :disabled="this.formClient.insert == false" auto-complete="nops" v-model="formClient.cnpj"
              clearable v-mask="['##.###.###/####-##', '###.###.###-##']"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Razão Social">
            <el-input auto-complete="nops" v-model="formClient.razaoSocial" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Apelido">
            <el-input auto-complete="nops" v-model="formClient.apelido" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Endereço">
            <el-input auto-complete="nops" v-model="formClient.endereco" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Número">
            <el-input auto-complete="nops" v-model="formClient.enderecoNro" clearable style="width:35%"
              v-mask="'##########'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Bairro">
            <el-input auto-complete="nops" v-model="formClient.bairro" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Cidade">
            <el-select auto-complete="nops" style="width:100%" filterable v-model="formClient.cidadesSel"
              placeholder="Selecione a cidade">
              <!-- <el-select auto-complete="nops" style="width:100%" v-model="formClient.cidadesSel" placeholder="Selecione a cidade"> -->
              <el-option v-for="item in formClient.cidadesObj" :key="item.id" :label="item.cidade" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Telefone">
            <el-input auto-complete="nops" v-model="formClient.telefone" clearable
              v-mask="['## ####-####', '## #####-####']"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Contato">
            <el-input auto-complete="nops" v-model="formClient.contato" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="E-mail">
            <el-input auto-complete="nops" v-model="formClient.email" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Cod. MR">
            <el-tooltip class="item" effect="dark" content="Código do cliente no MR Admin (sistema interno da MR)"
              placement="bottom">
              <el-input auto-complete="nops" v-model="formClient.codSistemaInterno" clearable style="width:35%"
                v-mask="'##########'"></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Tipo">
            <el-radio-group v-model="formClient.matrizFilial">
              <el-radio-button label="M">Matriz</el-radio-button>
              <el-radio-button label="F">Filial</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Cliente ativo">
            <el-switch inactive-color="#ff4949" v-model="formClient.ativo" active-value="S" inactive-value="N">
            </el-switch>
          </el-form-item>
        </el-col>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="hideDialog">Cancelar</el-button>
        <!-- <el-button size="medium" type="primary" :loading=formClient.sendLoading @click="sendEmailNfe('formClient')">Salvar</el-button> -->
        <el-button size="medium" type="primary" :loading=formClient.sendLoading
          @click="saveClient(formClient)">Salvar</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import { Message } from "element-ui";
import { mask } from "vue-the-mask"; // https://vuejs-tips.github.io/vue-the-mask/
import { apiGetCidades, apiGetClientes, apiDeleteCliente, apiUpdateCliente, apiInsertCliente } from "../../api/api";

// Clona um objeto
const cloneObj = (obj) => {
  if (null == obj || "object" != typeof obj) return obj;
  var copy = obj.constructor();
  for (var attr in obj) {
    if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
  }
  return copy;
}

export default {
  name: "clientes",
  // props: ["listaNfe", "listLoading", "descrEmitDest", "totalReg"],
  components: {},
  directives: {
    mask
  },
  data () {
    return {
      listaClientes: [],
      pageNumber: 1,
      pageSize: 10,
      totalReg: 0,
      listLoading: false,
      dialogVisible: false,
      dialogCreated: true,
      formClient: {
        insert: true,
        cnpj: '',
        razaoSocial: '',
        apelido: '',
        endereco: '',
        enderecoNro: '',
        bairro: '',
        contato: '',
        telefone: '',
        email: '',
        matrizFilial: 'M',
        ativo: 'S',
        codSistemaInterno: 0,
        codigoCidade: 0,
        codigoPlano: 0,
        sendLoading: false,
        cidadesObj: [],
        cidadesSel: "",
      },
    };
  },

  methods: {
    showDialogEdit (row) {
      apiGetCidades()
        .then(data => {
          this.formClient.cidadesObj = data;
          // this.formClient.cidadesSel = data[Object.keys(data)[0]].id;
        })
        .catch(error => { console.log('error: ' + error) });
      this.formClient.insert = false;
      this.formClient.cnpj = row.cnpj;
      this.formClient.razaoSocial = row.razaoSocial;
      this.formClient.apelido = row.apelido;
      this.formClient.endereco = row.endereco;
      this.formClient.enderecoNro = row.enderecoNro;
      this.formClient.bairro = row.bairro;
      this.formClient.contato = row.contato;
      this.formClient.telefone = row.telefone;
      this.formClient.email = row.email;
      this.formClient.matrizFilial = row.matrizFilial;
      this.formClient.ativo = row.ativo;
      this.formClient.codSistemaInterno = row.codSistemaInterno;
      this.formClient.codigoCidade = row.codigoCidade;
      this.formClient.cidadesSel = row.codigoCidade;
      this.dialogCreated = true;
      this.dialogVisible = true;
    },
    showDialogInsert () {
      apiGetCidades()
        .then(data => {
          this.formClient.cidadesObj = data;
          // this.formClient.cidadesSel = data[Object.keys(data)[0]].id;
        })
        .catch(error => { console.log('error: ' + error) });
      this.formClient.insert = true;
      this.formClient.cnpj = '';
      this.formClient.razaoSocial = '';
      this.formClient.apelido = '';
      this.formClient.endereco = '';
      this.formClient.enderecoNro = '';
      this.formClient.bairro = '';
      this.formClient.contato = '';
      this.formClient.telefone = '';
      this.formClient.email = '';
      this.formClient.matrizFilial = 'M';
      this.formClient.ativo = 'S';
      this.formClient.codSistemaInterno = 0;
      this.formClient.codigoCidade = 0;
      this.formClient.cidadesSel = '';
      this.dialogCreated = true;
      this.dialogVisible = true;
    },
    hideDialog () {
      this.dialogVisible = false;
      this.dialogCreated = false;
    },
    handleCurrentChange (val) {
      this.pageNumber = val;
      this.getClientes(this.pageNumber, this.pageSize);
    },
    handleSizeChange (val) {
      this.pageSize = val;
      this.getClientes(this.pageNumber, this.pageSize);
    },
    getClientes (pageNumber, pageSize) {
      this.listLoading = true;
      const params = {}
      if ((pageSize) && (pageNumber)) {
        params["limit"] = pageSize
        params["page"] = pageNumber
      } else {
        params["limit"] = this.pageSize
        params["page"] = this.pageNumber
      }
      apiGetClientes(params)
        .then(res => {
          this.listaClientes = res.clientes;
          this.totalReg = parseInt(res.totalReg);
          this.listLoading = false;
        })
        .catch(error => {
          this.listLoading = false;
        });
    },
    deleteCliente (cnpj, cnpjFormat, razaoSocial) {
      this.$confirm("<strong>" + cnpjFormat + " - " + razaoSocial + "</strong><br><br>" +
        "Tem certeza que deseja excluir o cliente selecionado?", "Excluir Cliente", {
        type: 'warning', dangerouslyUseHTMLString: true
      })
        .then(() => {
          apiDeleteCliente(cnpj)
            .then(res => {
              Message.success('Cliente excluído com sucesso!');
              this.getClientes()
            })
            .catch(error => {
              Message.error('Não foi possível excluir o cliente!');
              this.listLoading = false;
            });
        })
        .catch(() => { });
    },
    saveClient (form) {
      this.formClient.sendLoading = true
      const params = cloneObj(form)
      // Remove formatacao do cnpj
      params['cnpj'] = params['cnpj']
        .replace(/\./g, "")
        .replace(/\-/g, "")
        .replace(/\//g, "");
      if (params.cidadesSel) {
        params['codigoCidade'] = params.cidadesSel
      } else {
        params['codigoCidade'] = 0
      }
      // remove chaves desnecessarias
      params['codSistemaInterno'] = parseInt(params.codSistemaInterno)
      delete params.cidadesObj
      delete params.cidadesSel
      delete params.sendLoading
      delete params.insert

      if (form.insert == true) {
        apiInsertCliente(params)
          .then(data => {
            this.formClient.sendLoading = false
            Message.success('Cliente incluído com sucesso!');
            this.getClientes()
            this.hideDialog()
          })
          .catch(error => {
            console.log('error: ' + error)
            this.formClient.sendLoading = false
          });
      } else {
        apiUpdateCliente(params['cnpj'], params)
          .then(data => {
            this.formClient.sendLoading = false
            Message.success('Cliente atualizado com sucesso!');
            this.getClientes()
            this.hideDialog()
          })
          .catch(error => {
            console.log('error: ' + error)
            this.formClient.sendLoading = false
          });
      }
    },
    downloadXmlCliente (cnpj) {
      Message.warning('Ação ainda não disponível!');
    }
  },
  mounted () {
    this.getClientes();
  }
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/admin/clientes.vue